export enum CompanyBannerType {
  SystemBanner = 'system_banner',
  AdBanner = 'ad_banner',
  CompanyBanner = 'company_banner',
}

export interface CompanyBanner {
  id: string;
  description: string;
  images: string[];
  bannerType: CompanyBannerType;
  layoutId?: string;
  createdAt: string;
  updatedAt: string;
}

export interface NewCompanyBanner {
  description: string;
  bannerType: CompanyBannerType;
  layoutId?: string;
}

export interface CompanyBannersPayload {
  items: CompanyBanner[];
  total: number;
}
